export default function Content({ mainView }) {
  return (
    <main className='bg-black text-white w-full py-0 overflow-y-scroll'>
      {mainView}
    </main>
  )
}
